module.exports = __webpack_public_path__ + "static/img/tokamak-open.45d52ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tokamak-open.jpg
// module id = bsXc
// module chunks = 0